module.exports = __webpack_public_path__ + "img/advance.04887ddb.png";